/**
 * Format bytes to a human-readable string (KB / MB).
 * @param {number} bytes
 * @returns {string}
 */
export function formatFileSize(bytes) {
	if (!bytes && bytes !== 0) {
		return "";
	}
	if (bytes < 1024 * 1024) {
		return `${(bytes / 1024).toFixed(1)} KB`;
	}
	return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

/** Accepted MIME types for logo upload */
export const ACCEPTED_LOGO_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp"];

/** Max logo file size in bytes (5 MB) */
export const MAX_LOGO_SIZE_BYTES = 5 * 1024 * 1024;

/**
 * Validate a File object against logo upload constraints.
 * @param {File} file
 * @returns {{ valid: boolean, error: string|null }}
 */
export function validateLogoFile(file) {
	if (!file) {
		return { valid: false, error: "No file selected" };
	}
	if (!ACCEPTED_LOGO_TYPES.includes(file.type)) {
		return { valid: false, error: "invalid-type" };
	}
	if (file.size > MAX_LOGO_SIZE_BYTES) {
		return { valid: false, error: "size-exceeded" };
	}
	return { valid: true, error: null };
}
